import React, { Component } from 'react';
import { Button } from 'carbon-components-react';
import { CardLoader, CommentCard } from '../../../../components';
import CommentModal from '../../../../components/Modal/CommentModal';
import { getDmService } from '../../../../services/Api';

class Comments extends Component {
  state = {
    data: [],
    isLoading: true,
  };

  componentDidMount() {
    this.loadComments();
  }

  loadComments = async () => {
    try {
      const { order } = this.props;
      const data = await getDmService(
        `Comentario/GetByItemPedido/${order.itensCampanhaMensagem[0].id}`,
      );
      this.setState({ data, isLoading: false });
    } catch (e) {
      this.setState({ isLoading: false });
    }
  };

  updateCount = async id => {
    const {updateCount} = this.props
    await updateCount(id)
  }

  render() {
    const { data, isLoading } = this.state;
    const { order } = this.props;

    if (isLoading) {
      return <CardLoader lines={10} />;
    }

    return (
      <div className="v-md-margin">
        {!data.length ? (
          <div className="empty-comments">Nenhum comentário criado.</div>
        ) : (
          data.map(comment => <CommentCard key={comment.id} comment={comment} />)
        )}

        <Button
          className="bx--btn--full-width v-md-margin"
          onClick={() => this.commentModal.open()}
        >
          Adicionar Comentário
        </Button>

        <CommentModal
          onRef={ref => {
            this.commentModal = ref;
          }}
          orderId={order.itensCampanhaMensagem[0].id}
          onSave={() => this.loadComments()}
          updateCount={e => this.updateCount(e)}
        />
      </div>
    );
  }
}

export default Comments;



// WEBPACK FOOTER //
// ./src/screens/admin/MessagesCampaigns/Detail/Comments.js